<template>
  <div class="table-container">
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="5"
    >
      <template v-slot:item.img="props">
        <div class="name-slot">
          <v-img
            :src="props.item.img"
            width="71.5px"
            max-height="64.74px"
            style="border-radius: 10px"
          ></v-img>
        </div>
      </template>
      <template v-slot:item.musterverordnung="props">
        <v-btn
          class="mx-auto download-btn"
          outlined
          depressed
          @click="onButtonClick(props.item)"
        >
          Herunterladen
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: "",
          value: "img",
          align: "left",
          sortable: false,
        },
        {
          text: "Gewähltes Produkt",
          value: "name",
          align: "left",
          sortable: false,
        },
        {
          text: "Listenpreis",
          value: "Listenpreis",
          align: "right",
          sortable: false,
        },
        {
          text: "Übernahme",
          value: "Übernahme",
          align: "right",
          sortable: false,
        },
        {
          text: "Eigenanteil",
          value: "Eigenanteil",
          align: "right",
          sortable: false,
        },
        {
          text: "Musterverordnung",
          value: "musterverordnung",
          align: "center",

          sortable: false,
        },
      ],
      items: [
        {
          img: "https://images.unsplash.com/photo-1609900179119-3ed9f4530eb8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80",
          name: "Frozen Yogurt",
          Listenpreis: "229,00€",
          Übernahme: "- 69,00€",
          Eigenanteil: "160,00€",
        },
        {
          img: "https://images.unsplash.com/photo-1636910607308-57b9193885c9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80",
          name: "Ice cream sandwich",
          Listenpreis: "99,00€",
          Übernahme: "- 89,10€",
          Eigenanteil: "9,90€",
        },
      ],
    };
  },
};
</script>

<style>
</style>